module.exports = __webpack_public_path__ + "img/dummy10.57204eb.jpg";